import { setPlatformChannelsStatus } from '@liefersoft/pos-ui-core'
import { getActiveBreakDateTo, isOrderTypeClosed, notifyFranchiseChange } from './helper'

const WEBSHOP_WIDGET_PLATFORM_ID = 'webshop'
const RESTAURANT_CHANNELS = ['delivery', 'pickup']
const SUPPORTED_ORDER_TYPE_CHANNELS = { DELIVERY: ['delivery'], PICKUP: ['pickup'] }

export const applyRestaurantsWorkingStatusThunk = (data) => (dispatch) => {
	data.restaurants.forEach(restaurant => dispatch(setPlatformChannelsStatus({
		id: restaurant.restaurantId,
		channels: RESTAURANT_CHANNELS,
		status: restaurant.workingStatus,
		breakDateTo: restaurant.breakDateTo,
	})))
	notifyFranchiseChange(data)
}

export const applyOrderTypesWorkingStatusThunk = (data) => (dispatch) => {
	data.orderTypes
		.filter(orderType => SUPPORTED_ORDER_TYPE_CHANNELS[orderType.orderType])
		.forEach(orderType => dispatch(setPlatformChannelsStatus({
			id: WEBSHOP_WIDGET_PLATFORM_ID,
			channels: SUPPORTED_ORDER_TYPE_CHANNELS[orderType.orderType],
			status: isOrderTypeClosed(orderType) ? 'TEMPORARILY_CLOSED' : 'OPEN',
			breakDateTo: getActiveBreakDateTo(orderType),
		})))
	notifyFranchiseChange(data)
}
